/** Production-only gate for Sentry SDK init (no localhost / staging). */
export function shouldInitSentry(mode: string, dsn: string | undefined): boolean {
  if (mode !== "production") {
    return false;
  }

  if (!dsn?.trim()) {
    return false;
  }

  return true;
}
